import {useEffect} from "react";

import {
  useDomainPharmacy,
  usePharmacy,
} from "liberty-core/api/react-query/pharmacy";

import {useAuthenticatedUser} from "lib/auth";
import {getLocalStorageOrDefault, saveLocalStorage} from "lib/storage";

const domainPharmacyIdKey = "domainPharmacyId";
const defaultDomainPharmacyId = parseInt(
  getLocalStorageOrDefault(domainPharmacyIdKey, "0"),
);

export function useCurrentPharmacy() {
  const [authenticatedUser, loadingAuth] = useAuthenticatedUser();
  const {data: domainPharmacy, isLoading: isLoadingPharmacyId} =
    useDomainPharmacy(window.location.host.split(".")[0], {
      enabled: !loadingAuth && !authenticatedUser,
    });
  const {data: pharmacy, isLoading: isLoadingPharmacy} = usePharmacy(
    domainPharmacy?.id || defaultDomainPharmacyId,
    {enabled: !isLoadingPharmacyId && !loadingAuth && !authenticatedUser},
  );

  useEffect(() => {
    if (domainPharmacy?.id === undefined) {
      return;
    }
    saveLocalStorage(domainPharmacyIdKey, String(domainPharmacy?.id));
  }, [domainPharmacy?.id]);

  return [
    authenticatedUser?.data.pharmacy ?? pharmacy,
    loadingAuth || isLoadingPharmacy || isLoadingPharmacyId,
  ] as const;
}
